import React from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Hr } from "./hr";

interface TitleProps {
  children: React.ReactNode;
}
const Title: React.FC<TitleProps> = ({children}) => <h6 className="pb-2 fw-bold">{children}</h6>

interface TextProps {
  children: React.ReactNode;
}
const Text: React.FC<TextProps> = ({children}) => <p className="pb-0 ps-3">{children}</p>

export const Conditions: React.FC = () => {
  const { t } = useTranslation("translations", { keyPrefix: "EMPLOYMENT.CONDITIONS" })
  return (
    <Col md="12" className="p-3">
      <div className="p-5 h-100 bg-light rounded">
        <h3>{t("TITLE")}</h3>
        <Hr />
        <Row className="mt-5 text-start">
          <Col md="6">
            <Title>{t("DESCRIPTION.TITLE")}</Title>
            <Text>{t("DESCRIPTION.1")}</Text>
            <Text>{t("DESCRIPTION.2")}</Text>
            <Title>{t("LOCATION.TITLE")}</Title>
            <Text>{t("LOCATION.1")}</Text>
            <Text>{t("LOCATION.2")}</Text>
            <Text>{t("LOCATION.3")}</Text>
            <Title>{t("HOURS.TITLE")}</Title>
            <Text>{t("HOURS.STANDARD")}</Text>
            <Text>{t("HOURS.FLEX")}</Text>
            <Title>{t("SALARY.TITLE")}</Title>
            <Text>{t("SALARY.PREFERENCE")}</Text>
            <Text>{t("SALARY.OVERTIME")}</Text>
          </Col>
          <Col md="6">
            <Title>{t("HOLIDAY.TITLE")}</Title>
            <Text>{t("HOLIDAY.STANDARD")}</Text>
            <Title>{t("BENEFITS.TITLE")}</Title>
            <Text>{t("BENEFITS.TRANSPORTATION")}</Text>
            <Text>{t("BENEFITS.INSURANCE")}</Text>
            <Text>{t("BENEFITS.RETIREMENT")}</Text>
            <Text>{t("BENEFITS.BONUS")}</Text>
            <Title>{t("OTHERS.TITLE")}</Title>
            <Text>
              {t("OTHERS.RULES_PREFIX")}<a href="https://github.com/mk-system/MK-Rules">GitHub</a>{t("OTHERS.RULES_SUFFIX")}
            </Text>
          </Col>
        </Row>
      </div>
    </Col>
  )
}
